/**
 * TaskLogService
 * Service for TaskLog entity operations
 * Route: api/task-log
 */
import { CrudService } from '../base/CrudService';
/**
 * TaskLogService
 * Handles task log CRUD operations (read-only)
 */
export class TaskLogService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? TaskLogService.DEFAULT_SERVICE_PATH,
            basePath: TaskLogService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET ALL VIEWS ====================
    /**
     * Get all log views
     * GET api/task-log/view
     */
    async getAllViews() {
        const response = await this.getAllViewsRaw();
        return response.data ?? [];
    }
    /**
     * Get all log views with full response
     */
    getAllViewsRaw() {
        const endpoint = this.getEndpoint('all-views', 'view');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== GET BY TASK ID ====================
    /**
     * Get all logs for a task
     * GET api/task-log/task/{taskId}
     */
    async getByTaskId(taskId) {
        const response = await this.getByTaskIdRaw(taskId);
        return response.data ?? [];
    }
    /**
     * Get all logs for a task with full response
     */
    getByTaskIdRaw(taskId) {
        const endpoint = this.getEndpoint('by-task', `task/${taskId}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== GET VIEWS BY TASK ID ====================
    /**
     * Get log views for a task
     * GET api/task-log/task/{taskId}/view
     */
    async getViewsByTaskId(taskId) {
        const response = await this.getViewsByTaskIdRaw(taskId);
        return response.data ?? [];
    }
    /**
     * Get log views for a task with full response
     */
    getViewsByTaskIdRaw(taskId) {
        const endpoint = this.getEndpoint('views-by-task', `task/${taskId}/view`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== GET VIEW BY ID ====================
    /**
     * Get log view by ID
     * GET api/task-log/view/{id}
     */
    async getViewById(id) {
        const response = await this.getViewByIdRaw(id);
        if (!response.data) {
            throw new Error(`Log view ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get log view by ID with full response
     */
    getViewByIdRaw(id) {
        const endpoint = this.getEndpoint('view-by-id', `view/${id}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
}
TaskLogService.DEFAULT_SERVICE_PATH = 'tasks';
TaskLogService.BASE_PATH = 'api/task-log';
//# sourceMappingURL=TaskLogService.js.map